export const aboutInfo = {
  brandName: '亚洲一级日本精选内容导航平台',
  slogan: '汇聚亚洲精华，精选日本一级内容',
  introduction: '亚洲一级日本精选内容导航平台成立于2024年，致力于为全球中文用户提供最优质的亚洲与日本内容导航服务。我们的团队由来自中国、日本及亚洲各国的资深内容编辑、文化研究者和技术专家组成，凭借对亚洲文化的深刻理解和专业的内容筛选能力，打造了一个独具特色的精品内容导航平台。',
  mission: '我们的使命是成为连接中国用户与日本优质内容的桥梁，通过专业的分级筛选和精准的内容推荐，让每一位用户都能轻松找到自己感兴趣的亚洲一级内容，感受日本文化的独特魅力。',
  values: [
    { title: '品质至上', description: '每一篇内容都经过严格的分级筛选，确保用户接触到的是真正的优质资源。' },
    { title: '文化尊重', description: '我们尊重每一种文化的独特性，致力于促进亚洲各国之间的文化交流与理解。' },
    { title: '用户体验', description: '简洁高效的导航设计，让用户能够快速找到所需内容，节省宝贵时间。' },
    { title: '持续创新', description: '不断优化内容筛选算法和推荐机制，为用户带来更好的使用体验。' },
  ],
  stats: [
    { label: '内容条目', value: '6,500+' },
    { label: '内容分类', value: '6大' },
    { label: '月活跃用户', value: '50万+' },
    { label: '合作创作者', value: '300+' },
  ],
  contact: {
    email: 'contact@asia-japan-premium.com',
    address: '东京都港区六本木6-10-1 六本木ヒルズ森タワー',
    phone: '+81-3-1234-5678',
    wechat: 'AsiaJapanPremium',
  },
  reputation: [
    { title: '2025年度最佳内容导航平台', source: '亚洲数字媒体协会', year: '2025' },
    { title: '用户满意度评分 4.8/5.0', source: '独立第三方评测机构', year: '2026' },
    { title: '日本文化传播贡献奖', source: '日中文化交流协会', year: '2025' },
    { title: '年度十大新锐内容平台', source: '亚洲互联网产业联盟', year: '2026' },
  ],
};